
export type GetRoadmapsSortOrder = typeof GetRoadmapsSortOrder[keyof typeof GetRoadmapsSortOrder];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRoadmapsSortOrder = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
